import { useContext } from 'react'

import { DocFlowMappingContext } from '../../DocFlowMapping'

export function useDocFlowMappingContext() {
  return useContext(DocFlowMappingContext)
}
